export default class ClickStat {
    public readonly name: string;

    // The number of human clicks in this period 1
    public human: number;

    // The number of unique clicks in this period
    public unique: number;

    // The number of bot clicks in this period
    public bots: number;

    // The total numer of clicks in this period. If no value provided we sum up all the other clicks
    public total: number;

    // The total visitors in this period
    public visitors: number;

    // The total of active links in the this period
    public active: number;

    constructor(
        name: string,
        human: number = 0,
        unique: number = 0,
        bots: number = 0,
        total: number | null = null,
        visitors: number = 0,
        active = 0,
    ) {
        this.human = human;
        this.unique = unique;
        this.bots = bots;
        this.name = name;
        this.visitors = visitors;
        this.active = active;

        if (total) {
            this.total = total;
        }
        else {
            this.total = human + unique + bots;
        }
    }

    public getChartTotal(): ClickStat {
        return this;
    }

    public getChartData(): ClickStat[] {
        return [this];
    }
}  
